import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { setMessage } from "../elements/alert/Action";
import { requestData } from "../helpers/requestData";
import { createParticipantAction, saveUserAnswerAction, createBrowserDataAction, fetchWelcomeMessageAction } from "../../actions/participant";
import Demographics from '../elements/demographics';
import * as rdd from 'react-device-detect';
//import { getFingerprint } from 'fingerprintjs-pro';
import { useUserActivityTracker } from '../useUserActivity';
import { useFingerprintPro } from '../helpers/getFingerprint'; // Import the custom hook
import Cookies from 'universal-cookie';
import WelcomeMessage from '../elements/WelcomeMessage';
const cookies = new Cookies();

const Home = (props) => {

    let [createParticipantApiCalled, setCreateParticipantApiCalled] = useState();
    let [content, setContent] = useState();
    let [showSurvey, setShowSurvey] = useState(false);
    const { refetch } = useFingerprintPro(); // Use the hook here
    const COOKIE_NAME = "fingerprint_id";
    
    let activityData = useUserActivityTracker();
    // Get Data Query from URL Here
    // Check the vid is Present
    // call the create Participant API

   const setBrowserData = (browserData) => {
        return browserData;
    };

    let allRequestData = requestData(window);

    let browserData = setBrowserData(rdd);

    function toQueryParams(obj = {}) {
      const params = new URLSearchParams();
      for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
          params.append(key, obj[key]);
        }
      }
      return params.toString();
    }

    useEffect(() => {
        const fetchWelcomeMessage = async () => {
            await props.fetchWelcomeMessageAction();
        }
        fetchWelcomeMessage();
    }, []);

    useEffect(() => {
        if (props.alertMessage == "" && allRequestData.badUrlHitting) {
            props.setMessage({ success: false, message: "You are hitting a bad url." })
        };

       
    }, [props.alertMessage]);

    // Call the Create Participant API
    
    useEffect(()=>{
        const fetchFingerprint = async () => {
            let visitorId = '';
            // const fingerprint = await getFingerprint("c57025871028cb12311bd142ba72ae573a4bdeca723");
            // if (fingerprint.success) {
            //   visitorId = fingerprint.visitorId;
           
            // }


            let savedFingerprintId = cookies.get(COOKIE_NAME);
            if (!savedFingerprintId || savedFingerprintId === 'null') {

                await refetch(); // Ensure fingerprint is fetched
                let savedFingerprintId = cookies.get(COOKIE_NAME);
                visitorId = savedFingerprintId ? savedFingerprintId : '';
            } else {
                visitorId = savedFingerprintId;
            }

            
            
            return visitorId;
          };

        
        const fetchData = async () => {
            if (!createParticipantApiCalled && !allRequestData.badUrlHitting && activityData && props.welcomeMessageSuccess && props.isVisible === 0) {
                // call action of API
                let visitorId = await fetchFingerprint();
                let allQueryParams = allRequestData.urlQueryString;
                allQueryParams = allQueryParams + "&platformVisitorId=" + visitorId + "&" + toQueryParams(activityData);
                let landingURL = allRequestData.landingURL;
                setCreateParticipantApiCalled(true);
                props.createParticipantAction(allQueryParams, landingURL);
            }
        };
        fetchData();
    }, [activityData, showSurvey, props.isVisible, props.welcomeMessageSuccess])

    useEffect(()=>{
        if(!createParticipantApiCalled && !allRequestData.badUrlHitting){
            // call action of API
            let allQueryParams = allRequestData.urlQueryString;
            let landingURL = allRequestData.landingURL;
            let postData = {
                allQueryParams, landingURL, browserData
            }
            props.createBrowserDataAction(postData);
        }
    }, [])

    useEffect(()=>{

        let demos = "";
        if(props.demographicsData){
            demos =   <Demographics allDemos = {props.demographicsData}/>
            setContent(demos)
        }

    }, [props.demographicsData])


    const handleStartSurvey = async () => {
        setShowSurvey(true);
        if (!createParticipantApiCalled && !allRequestData.badUrlHitting && activityData) {
            let visitorId = '';
            let savedFingerprintId = cookies.get(COOKIE_NAME);
            if (!savedFingerprintId || savedFingerprintId === 'null') {
                await refetch();
                savedFingerprintId = cookies.get(COOKIE_NAME);
                visitorId = savedFingerprintId ? savedFingerprintId : '';
            } else {
                visitorId = savedFingerprintId;
            }

            let allQueryParams = allRequestData.urlQueryString;
            allQueryParams += "&platformVisitorId=" + visitorId + "&" + toQueryParams(activityData);
            let landingURL = allRequestData.landingURL;

            setCreateParticipantApiCalled(true);
            props.createParticipantAction(allQueryParams, landingURL);
        }
    };

    return (
        <>
            {(props.isVisible === 1 && !showSurvey) ? (
                <WelcomeMessage
                    content={props.welcomeMessage}
                    fetchData={handleStartSurvey}

                />
            ) : (
                <div>{content}</div>
            )}
        </>
    )
}
const mapStateToProps = (state) => {
    return {
        alertMessage: state.alert.alertMessage,
        demographicsData: state.participant.demographicsData,
        welcomeMessage : state.participant.welcomeMessage,
        isVisible : state.participant.isVisible?1:0,
        welcomeMessageSuccess : state.participant.welcomeMessageSuccess,
    }
}
export default connect(mapStateToProps, {
    setMessage, createParticipantAction, createBrowserDataAction,fetchWelcomeMessageAction
})(Home);
